import BigNumber from "bignumber.js";
export const serializeCryptoOrgTransaction = ({ family, mode, fees, amount, recipient, }) => ({
    family,
    amount: amount.toString(),
    recipient,
    fees: fees ? fees.toString() : undefined,
    mode,
});
export const deserializeCryptoOrgTransaction = ({ family, mode, fees, amount, recipient, }) => ({
    family,
    amount: new BigNumber(amount),
    recipient,
    fees: fees ? new BigNumber(fees) : undefined,
    mode,
});
//# sourceMappingURL=serializer.js.map